(function () {
    'use strict';
    var buttonCounter = 0;

    angular.module('SMART2').directive('smartButton', ['$timeout', 'persistenceService', function ($timeout, persistenceService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                callback: "&",
                onClick: "&",
                config: "=",
                backgroundColor: "=",
                fabConfig: "=",
                flat: "=",
                disable: "=",
                callbackParams: "=",
                buttonType: "="
            },
            link: function (scope, element, attrs) {
                buttonCounter++;
                var buttonId = buttonCounter;
                // scope.buttonId = "button-" + (scope.config.title ? scope.config.title.replace(/[&\/\\#,+()$~%.'":*?<>{} ]/g, '_') : buttonId);

                //check is floating
                scope.isFloating = (attrs.floating) ? scope.$eval(attrs.floating) : false;

                //check is large
                scope.isLarge = (attrs.large) ? scope.$eval(attrs.large) : false;

                //click callback
                var callback = scope.$eval(scope.callback);
           
                //following code is added for Pendo
                var tmpId = '';
                if(attrs.id){
                    tmpId = "button_" + attrs.id;        
                    var tmpElementCount = $('#' + tmpId).length;
                    if(tmpElementCount > 0) {
                        tmpId = tmpId + '_' + buttonCounter;
                    }
                } else {
                    tmpId = "button_" + buttonCounter;
                }
                scope.btnId = tmpId;

                //Local click binding
                scope.clickCallback = function (e) {
                    e.goBack= persistenceService.redirectToPreviousNode;
                    if (!scope.buttonType  || (scope.buttonType && scope.buttonType != "Cancel")) {
                        if (!scope.disable) {
                            if (angular.isFunction(callback)) {
                                callback(e, scope.callbackParams)
                            };
                            scope.onClick({ $event: e });
                        }
                    }
                    else {
                        persistenceService.redirectToPreviousNode();
                    }
                };

                attrs.$observe('ngClass', function (value) {
                    scope.styleClass = value;
                });
            },
            templateUrl: 'shared/directives/uiElements/smartButton/smartButtonTemplate.html'
        };
    }]);
})();